import { render, staticRenderFns } from "./AverageReviewsPerSupplierByAirport.vue?vue&type=template&id=21012ad4&scoped=true&"
import script from "./AverageReviewsPerSupplierByAirport.vue?vue&type=script&lang=js&"
export * from "./AverageReviewsPerSupplierByAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21012ad4",
  null
  
)

export default component.exports